import { hasWindow } from 'helpers/windowHelpers';
import { OwnerRoutesEnum } from 'routes/routes';

declare global {
  interface Window {
    // TODO - Remove NEXT_PUBLIC_VERSIOn once we have a stronger understanding of Unauthenticated Pages
    NEXT_PUBLIC_VERSION: 'guest' | 'owner';

    // For google tag manager analytics
    NEXT_PUBLIC_OWNER_EMAIL: string;
    NEXT_PUBLIC_BOOKING_COUNT: number;
  }
}

// The LIVE site refers to the application that has been built, and is live on alluradirect.com
// The opposite of this is a) Production build on staging , b) development build
export const IS_LIVE_SITE = (): boolean => {
  const isLiveString = process.env.NEXT_PUBLIC_IS_LIVE_SITE;
  if (!isLiveString) return false;
  if (isLiveString === 'false') return false;
  if (isLiveString === 'true') return true;
  return false;
};

export const IS_DIRECT_VACATIONS = (): boolean => {
  if (!hasWindow()) return false;
  return window.location.href.indexOf('directvacations') > 0;
};

export const getPropertyIdFromUrl = (): number => {
  if (!hasWindow()) return 0;
  // Our Dashboard / Onboarding  apps will be accessed using the /host/onboarding or /host/dashboard routes
  // Property ID will always follow the /onboarding or /dashboard part of the string
  // Therefore, we need to extract that part of the URL and parse it as a number
  // ie host/onboarding/123456789
  // propertyId = 123456789
  const pathname = window.location.pathname;
  const splitPath = pathname.split('/');

  const onboarding = OwnerRoutesEnum.onboarding.split('/')[2].replace(/\//g, '');
  const dashboard = OwnerRoutesEnum.dashboard.split('/')[2].replace(/\//g, '');

  const isOnboarding = splitPath.includes(onboarding);
  const isDashboard = splitPath.includes(dashboard);
  if (isOnboarding || isDashboard) {
    const onboardingIndex = splitPath.findIndex(item => item === onboarding);
    const dashboardIndex = splitPath.findIndex(item => item === dashboard);

    if (onboardingIndex !== -1 && onboardingIndex !== splitPath.length - 1) {
      const pid = splitPath[onboardingIndex + 1];
      return Number(pid);
    }

    if (dashboardIndex !== -1 && dashboardIndex !== splitPath.length - 1) {
      const pid = splitPath[dashboardIndex + 1];
      return Number(pid);
    }
  }

  return 0;
};

export const isDevelopment = process.env.NODE_ENV === 'development';

interface SetWindowVariables {
  version: 'guest' | 'owner';
  email: string;
}

export const setWindowVariables = (args: SetWindowVariables): void => {
  window.NEXT_PUBLIC_VERSION = args.version;
  window.NEXT_PUBLIC_OWNER_EMAIL = args.email;
};
